<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration Confirmation</h2>

                            <p>
                                You have successfully registered for
                                {{ conferenceTextData.name }} Conference. You will receive a
                                confirmation email shortly including your
                                registration information
                            </p>

                            <p>
                                <span>You can edit your registration details
                                    through the Application form that will be
                                    shared with you shortly with your username
                                    and password.</span>
                            </p>

                            <p>
                                If you need any further assistance, you may
                                contact us by email on
                                <a class="text_underline" :href="'mailto:' + conferenceTextData.conference_email">{{
                                    conferenceTextData.name }}</a>
                            </p>

                            <router-link to="/" class="btn btn-sm">Click here to view your dashboard</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { mapGetters } from 'vuex';

export default {
    name: "Thank",
    components: { Layout },
    computed: {
        ...mapGetters(['conferenceTextData'])
    },
};
</script>
